import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from './layout/layout.module';
import { MaterialModule } from './material/material.module';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { MasterDetailComponent } from './master-detail/master-detail.component';
import { CollectionComponent } from './collection/collection.component';
import { DetailComponent } from './detail/detail.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertDialogComponent } from './dialog/alert-dialog/alert-dialog.component';
import { ConfirmDialogComponent } from './dialog/confirm-dialog/confirm-dialog.component';
import { PanelButtonsComponent } from './panel-buttons/panel-buttons.component';
import { CmlFormsModule } from './cml-forms/cml-forms.module';
import { MasterDetailHub } from './master-detail/master-detail-hub.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { PrenosUcetniJednotkaDetailComponent } from '../prenos-ucetni-jednotka/prenos-ucetni-jednotka-component';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS} from '@angular/material-moment-adapter'
import { NastaveniUcetniJednotkyComponent } from '../nastaveni-ucetni-jednotka/nastaveni-ucetni-jednotka-detail.component';
import { UcetniJednotkaDetailComponent } from '../ucetni-jednotka/ucetni-jednotka-detail.component/ucetni-jednotka-detail.component';
import { DokladovaRadaComponent } from '../dokladova-rada/dokladova-rada.component';
import { FormDialogComponent } from './dialog/form-dialog/form-dialog.component';
import { DokladovaRadaTabulkaComponent } from '../dokladova-rada/dokladova-rada-tabulka/dokladova-rada-tabulka.component';
import { ExtendedDetailComponent } from './detail/new-detail/extended-detail.component';
import { UserRoleComponent } from '../user-role/user-role.component';
import { czDatePipe } from './pipes/date-pipe';
import { TableDialogComponent } from './cml-forms/show-table.dialog/table-dialog.component';
import { KontaceDetailComponent } from '../kontace/kontace-detail.component';
import { UcetniObdobiComponent } from '../ucetni-obdobi/ucetni-obdobi.component';
import { UctovyRozvrhDetailComponent } from '../uctovy-rozvrh/uctovy-rozvrh.detail.component';
import { UctovyRozvrhComponent } from '../uctovy-rozvrh/uctovy-rozvrh.component';
import { FromIntToEnumPipe } from './pipes/fromIntToEnum.pipe';
import {DefiniceVykazuComponent} from "../definice-vykazu/definice-vykazu.component";
import {MatIconModule} from "@angular/material/icon";
import {BooleanPipe} from "./pipes/boolean-pipe";
import {SnackBarComponent} from "./dialog/snack-bar/snack-bar/snack-bar.component";
import {DefiniceFormatVykazuDetailComponent} from "../definice-vykazu-format/definice-format-vykazu-detail.component";
import {
  VysledekVypoctuVykazuDetailComponent
} from "../vysledek-vypoctu-vykazu/vysledek-vypoctu-vykazu-detail.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {
  DokladovaRadaFormDialogService,
} from "../dokladova-rada/dokladova-rada-form-dialog-service";
import {UctovyRozvrhFormDialogService} from "../uctovy-rozvrh/uctovy-rozvrh-form-dialog-service";
import {DefiniceVykazuFormDialogService} from "../definice-vykazu/definice-vykazu-form-dialog-service";
import {
  VysledekVypoctuVykazuFormDialogService
} from "../vysledek-vypoctu-vykazu/vysledek-vypoctu-vykazu-form-dialog-service";
import {
  DefiniceFormatVykazuFormDialogService
} from "../definice-vykazu-format/definice-format-vykazu-form-dialog-service";
import { ToolbarDirective } from './panel-buttons/toolbarDirective/toolbar-directive.directive';
import {
  CroRegistrationFormDialogServiceComponent
} from "../cro-registration/cro-registration-form-dialog-service.component";
import {UcetniJednotkaDetailFormDialogService} from "../ucetni-jednotka/ucetni-jednotka-detail-form-dialog-service";
import {UcetniJednotkaFormDialogComponent} from "../ucetni-jednotka/ucetni-jednotka-form-dialog-component";
import {FromStringToEnumPipe} from "./pipes/fromStringToEnum.pipe";
@NgModule({
  declarations: [
    HomeComponent,
    MasterDetailComponent,
    CollectionComponent,
    DetailComponent,
    AlertDialogComponent,
    ConfirmDialogComponent,
    PanelButtonsComponent,
    PrenosUcetniJednotkaDetailComponent,
    NastaveniUcetniJednotkyComponent,
    UcetniJednotkaDetailComponent,
    DokladovaRadaComponent,
    DokladovaRadaFormDialogService,
    FormDialogComponent,
    DokladovaRadaTabulkaComponent,
    ExtendedDetailComponent,
    UserRoleComponent,
    TableDialogComponent,
    KontaceDetailComponent,
    czDatePipe,
    BooleanPipe,
    UcetniObdobiComponent,
    UctovyRozvrhDetailComponent,
    UctovyRozvrhComponent,
    UctovyRozvrhFormDialogService,
    FromIntToEnumPipe,
    FromStringToEnumPipe,
    DefiniceVykazuComponent,
    DefiniceVykazuFormDialogService,
    SnackBarComponent,
    DefiniceFormatVykazuDetailComponent,
    VysledekVypoctuVykazuDetailComponent,
    VysledekVypoctuVykazuFormDialogService,
    DefiniceFormatVykazuFormDialogService,
    UcetniJednotkaDetailFormDialogService,
    CroRegistrationFormDialogServiceComponent,
    UcetniJednotkaFormDialogComponent,
    ToolbarDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    LayoutModule,
    CmlFormsModule,
    MatIconModule,
    MatTooltipModule
  ],
  exports: [
    MaterialModule,
    ReactiveFormsModule,
    LayoutModule,
  ],
  providers: [
    MasterDetailHub,
    FromIntToEnumPipe,
    FromStringToEnumPipe,
   {provide: MAT_DATE_LOCALE, useValue: 'cs-CZ'},
   {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]},
   {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    BooleanPipe
  ],
})
export class SharedModule {
  constructor(private dateAdapter : DateAdapter<Date>) {
    this.dateAdapter.setLocale('cs-CZ');
  }
}
